import React, { useEffect, useState, useRef } from "react";
import "../../Styles/styles-StatusTracker.css";
import { useSelector, useDispatch } from "react-redux";
import { 
    Avatar,
    Tag,
    Typography,
    Input,
    Button,
    message
} from "antd";
import { getTextColorBasedOnBg } from '../../Utils/color_utils';
import Headshot from "../Player/Headshot";
import { CheckOutlined, DeleteOutlined } from '@ant-design/icons';
import { BlockPicker } from 'react-color';
import { 
    createCustomStatus, 
    updateCustomStatus
} from '../../store/actions/statustracker.actions'

const { Text } = Typography;

export const StatusUpdater = ({ uniqueKey, status, mode, confirmCancelHandler, dateHeaders }) => {
    const {
        info: { team_logo },
    } = useSelector(({ team }) => team);
    const inputRef = useRef(null);
    const dispatch = useDispatch();

    const {
        statuses
    } = useSelector(({ statusTracker }) => statusTracker);

    const [statusColor, setStatusColor] = useState(status?.color || "#e2efdc");
    const [statusName, setStatusName] = useState(status?.name);
    const [displayColorPicker, setDisplayColorPicker] = useState();

    const handleStatusNameChange = (val) => {
        setStatusName(val);
    }

    const handleColorChange = (hexColorStr) => {
        setStatusColor(hexColorStr.hex);
    }

    const handleStatusConfirm = () => {
        if (!statusName) {
            message.warning({
                content: "Custom status name can't be blank",
                duration: 5
            })
            return;
        }
        if (!statusColor) {
            message.warning({
                content: "Custom status color can't be blank",
                duration: 5
            })
            return;
        }

        const statusesWSameName = statuses.filter(s => {
            if (mode === "edit" && (status?.status_id !== s?.status_id || status?.id !== s?.id) && s.name.toLowerCase() === statusName.toLowerCase()) {
                return s
            } else if (mode !== "edit" && s.name.toLowerCase() === statusName.toLowerCase()) {
                return s
            } 
        });

        if (statusesWSameName.length > 0) {
            if (statusesWSameName[0].type === "built_in") {
                message.warning({
                    content: `This status name (${statusName}) is reserved and cannot be used.`,
                    duration: 5
                })
            } else {
                message.warning({
                    content: `This status name (${statusName}) is already in use.`,
                    duration: 5
                })
            }
            return;
        }

        let start_date, end_date;
        if (dateHeaders && Object.keys(dateHeaders).length > 0) {
            const datesToQuery = Object.keys(dateHeaders);
            start_date = datesToQuery[0];
            end_date = datesToQuery[datesToQuery.length - 1];
        }
        
        if (mode === "edit") {
            const params =  {
                name: statusName,
                color: statusColor,
                status_id: (status.status_id || status.id),
                start_date,
                end_date
            }
            dispatch(updateCustomStatus(uniqueKey, params, status.mapping));
        } else if (mode === "create") {
            const params =  {
                name: statusName,
                color: statusColor,
                start_date,
                end_date
            }
            dispatch(createCustomStatus(uniqueKey, params));
        }

        setStatusName(null);
        setStatusColor("#e2efdc");
        confirmCancelHandler();
    }

    const handleStatusCancel = () => {
        setStatusName(null);
        setStatusColor("#e2efdc");
        confirmCancelHandler();
    }

    const handleColorPicker = () => {
        setDisplayColorPicker(!displayColorPicker);
    }

    return (
        <div className="tracker-status-updater">
           <Input
                placeholder="Status Name"
                ref={inputRef}
                type="text"
                size="small"
                style={{ width: 130, height: 22 }}
                value={statusName}
                onChange={e => handleStatusNameChange(e.target.value)}
            />
            
            <div className='tracker-color-div-updater' style={{ backgroundColor: statusColor, cursor: 'pointer' }} onClick={handleColorPicker}></div>
            {/* Color picker popup */}
            {displayColorPicker && (
                <div style={{ position: 'absolute', zIndex: 2 }}>
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                    }}
                    onClick={handleColorPicker} // Close picker when clicking outside
                />
                    <BlockPicker
                        color={statusColor} // Set default color
                        onChangeComplete={handleColorChange} // Handle color change
                        colors={[
                            "#E2EFDC", "#FFE0B3", "#FFCCCC", "#E6FFEE", "#CDF5F6", 
                            "#EFF9DA", "#F2F2F2", "#FFE6FF", "#FFFFCC", "#E6EEFF"
                        ]} // Set custom color options
                    />
                </div>
            )}

            <Button 
                type="primary" 
                shape="circle" 
                icon={<CheckOutlined />} 
                className="create-status"
                onClick={handleStatusConfirm}
            />
            <Button 
                type="primary" 
                shape="circle" 
                danger 
                icon={<DeleteOutlined />} 
                className="delete-status"
                onClick={handleStatusCancel}
            />
        </div>
    );
};
